import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeCommodityListItem extends SearchModelBase {
    description: string = '';
    id: number = 0;
    code: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Commodity', width: 500, dataIndex: 'code'}),
        XCol.Create({ col: 1, text: 'Description', width: 500, dataIndex: 'description'})
        ];

    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeCommodityListItem.prototype.code, orderByAscending: false };

    public static formatData(data: CodeCommodityListItem[]) {
        return data.map((d: CodeCommodityListItem) => ({
          ...d,
        }));
    }

}
